import { render, staticRenderFns } from "./downing.vue?vue&type=template&id=0fcdebe0&scoped=true&"
import script from "./downing.vue?vue&type=script&lang=ts&"
export * from "./downing.vue?vue&type=script&lang=ts&"
import style0 from "./downing.vue?vue&type=style&index=0&id=0fcdebe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdebe0",
  null
  
)

export default component.exports